import type { CapiPlp } from 'types/capi/plp';

import BrazeBanner from '~/components/BrazeBanner';
import PageLoadErrorBoundary from '~/components/PageLoadErrorBoundary';
import seo from '~/utils/seo';

import PlpView, * as plp from '../PlpView';

export default function ClothingPlp() {
  return (
    <>
      <BrazeBanner placementId="plp-top" />
      <PlpView allowNotifications={false} />
    </>
  );
}

function isNotIndexable(location: Location) {
  const params = new URLSearchParams(location.search);

  return params.has('gender') || params.has('colour') || params.has('price');
}

type LoaderData = {
  pageData: CapiPlp;
};

export const handle = {
  i18n: ['plp']
};

export function ErrorBoundary() {
  return <PageLoadErrorBoundary pageType="plp" />;
}

export const shouldRevalidate = plp.shouldRevalidate;
export { loader } from '../loader.server';

export const meta = ({
  data,
  location
}: {
  data?: LoaderData;
  location: Location;
}) => {
  const meta = data
    ? seo.formatForMeta(data.pageData.canonical_url, data.pageData.seo)
    : [];

  if (isNotIndexable(location)) return seo.addMetaNoIndex(meta);

  return meta;
};
